import {Grid2 as Grid, Paper, TableContainer, Table, TableHead, TableRow, TableCell, Typography, TableBody} from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import miscReportChangeLog, { miscReportChangeLogDiff } from '../../../types/reports/miscReportChangeLog';


interface Props {
   changes?:miscReportChangeLog[];
}


const MiscChangeLogTable = (props: Props): JSX.Element => {

    const theme = useTheme();

    let changes = props.changes ?? [];

    // status comes as "Added", "Deleted", "Changed" or "Changed (Expenditure Total)" for summary fields
    const getStatusText = (change: miscReportChangeLog) => {
        return change.status.split(' (')[0];
    }

    const getItemText = (change: miscReportChangeLog) => {
        if(change.comparisionType === 'Summary'){
            let field = change.status.match(/\((.*)\)/);
            return field ? field[1] : 'Summary';
        }
        return getStatusText(change) === 'Deleted' ? change.previousDisplay : change.currentDisplay;
    }

    const setChangeType = (statusText: string) => {

        let statusColor = '';
        let statusBgColor = '';

        switch (statusText) {
            case 'Added':
                statusBgColor = alpha(theme.palette.success.light, 0.1);
                statusColor = theme.palette.success.dark;
                break;
            case 'Changed':
                statusBgColor = alpha(theme.palette.primary.light, 0.1);
                statusColor = theme.palette.primary.dark;
                statusText = 'Updated';
                break;
            case 'Deleted':
                statusBgColor = alpha(theme.palette.error.light, 0.1);
                statusColor = theme.palette.error.dark;
                break;
        }

        return (
            <Typography
                variant={'caption'}
                fontWeight={550}
                sx={{
                  bgcolor: `${statusBgColor}`,
                  color: `${statusColor}`,
                  paddingX: 1.5,
                  paddingY: 0.5,
                  borderRadius: 4,
                  display: 'inline',
                }}
              >
              {statusText}
              </Typography>
        );

    }

    const displayChanges = (change: miscReportChangeLog) => {
        if(getStatusText(change) !== 'Changed'){
            return null;
        }
        if(change.diffs && change.diffs.length > 0){
            return change.diffs.map((diff: miscReportChangeLogDiff, index) => (
                <Typography variant={'subtitle2'} key={index}>
                    <b>{diff.fieldName}</b>: {diff.previousValue}   {'→'}  <span style={{ color: 'blue' }}>{diff.currentValue}</span>
                </Typography>
            ));
        }
        return (
            <Typography variant={'subtitle2'}>
                {change.previousDisplay}   {'→'}  <span style={{ color: 'blue' }}>{change.currentDisplay}</span>
            </Typography>
        );
    }

    return (
        <Grid container spacing={1}>
         <TableContainer component={Paper}>
             <Table aria-label="change log table" size="small">
                 <TableHead>
                     <TableRow>
                         <TableCell>
                             <Typography variant={'subtitle2'} fontWeight={600}>
                                Category
                             </Typography>
                         </TableCell>
                         <TableCell>
                             <Typography variant={'subtitle2'} fontWeight={600}>
                                Item
                             </Typography>
                         </TableCell>
                         <TableCell>
                             <Typography variant={'subtitle2'} fontWeight={600}>
                                Type
                             </Typography>
                         </TableCell>
                         <TableCell>
                             <Typography variant={'subtitle2'} fontWeight={600}>
                                Changes
                             </Typography>
                         </TableCell>
                     </TableRow>
                 </TableHead>
                 <TableBody>
                     {changes.map((change: miscReportChangeLog, index) => (
                        <TableRow key={index}>
                            <TableCell>
                                <Typography variant={'subtitle2'}>
                                    {change.scheduleName ?? 'Summary'}
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant={'subtitle2'}>
                                    {getItemText(change)}
                                </Typography>
                            </TableCell>
                            <TableCell>
                                {setChangeType(getStatusText(change))}
                            </TableCell>
                            <TableCell>
                                {displayChanges(change)}
                            </TableCell>
                        </TableRow>
                    ))}
                 </TableBody>
             </Table>
         </TableContainer>
        </Grid>
    );
}

export default MiscChangeLogTable;
